module.exports = __webpack_public_path__ + "img/20200610_155505.7d6ea167.jpg";